export default __webpack_public_path__ + "468e21a90b573f915ba07b31c7887064.png";